import { graphql } from "@apollo/client/react/hoc"
import { useParams, useLocation } from "react-router-dom"
import { compose, withProps } from "recompose"
import moment from "moment"
import { CASE_LIST } from "../../apollo/queries"
import { archiveCaseMutation, deleteCaseMutation } from "../../apollo/mutations"
import CaseList from "."

const CaseListEnhanced = compose(
  withProps(() => {
    const { facilityId } = useParams()
    const { pathname } = useLocation()
    return {
      facilityId,
      caseType: pathname.includes("open") ? "open" : "archived",
    }
  }),
  graphql(CASE_LIST, {
    options: ({ facilityId, caseType }) => ({
      variables: {
        facilityId,
        archived: caseType === "archived" ? true : false,
      },
    }),
    props: ({ data: { error, loading, refetch, facility } }) => {
      if (error) throw error

      if (loading) return { loading }

      return {
        loading,
        facilityName: facility.name,
        cases: facility.contactTracingCases.map((kase) => ({
          id: kase.id,
          internalId: kase.internalId,
          type: kase.type,
          updatedAt: moment.parseZone(kase.updatedAt),
          locations:
            kase.type === "patientPositive"
              ? kase.subjects.map((loc) => loc.entity)
              : null,
          user:
            kase.type === "employeePositive" ? kase.subjects[0].entity : null,
          subjects: kase.subjects.map((subject) => ({
            entityId: subject.entity.id,
            startAt: moment.parseZone(subject.startAt),
            endAt: moment.parseZone(subject.endAt),
          })),
          startAt: moment.min(
            kase.subjects.map((s) => moment.parseZone(s.startAt))
          ),
          endAt: moment.max(
            kase.subjects.map((s) => moment.parseZone(s.endAt))
          ),
        })),
      }
    },
  }),
  archiveCaseMutation,
  deleteCaseMutation
)(CaseList)

export default CaseListEnhanced
